import React from "react";
import autoBind from "react-autobind";
import Paper from "@material-ui/core/Paper";
import Field from "../../components/Field";
import Logo from "../../components/Logo";
import Button from "@material-ui/core/Button";
import LinearProgress from "@material-ui/core/LinearProgress";
import {Redirect} from "react-router-dom";
import feathers from "../../feathers";
import {isStrongPassword} from "../../lib";

export default class PasswordReset extends React.Component {
  constructor(props) {
    super(props);
    this.resetService = feathers.service("auth/password-reset");
    this.state = {
      error: null,
      fetching: false,
      data: {
        password: "",
        confirmPassword: ""
      }
    };
    autoBind(this);
  }

  async handleSubmit(event) {
    try {
      event.preventDefault();
      const {resetToken} = this.props.location.query;
      const {password, confirmPassword} = this.state.data;
      this.setState({fetching: true, error: false});
      let user = await this.resetService.create({password, confirmPassword, resetToken});
      await feathers._authenticate({strategy: "local", email: user.email, password});
      this.props.onSuccess("/map");
    } catch (err) {
      this.setState({error: err.message, fetching: false});
    }
  }

  handleChange({name, value}) {
    this.setState({data: {...this.state.data, [name]: value}});
  }

  getPasswordHelp(password) {
    if (!password) {
      return "";
    } else {
      return isStrongPassword(password) ? "Great!" : "Please enter a stronger password.";
    }
  }

  render() {
    if (!this.props.location.query.resetToken) {
      return <Redirect to="/forgot-password" />;
    }
    const {password, confirmPassword} = this.state.data;
    return (
      <div className="unauthed-page">
        <div className="container-fluid">
          <div className="row middle-md middle-sm middle-xs">
            <div className="col-md-4 col-md-offset-4 col-sm-6 col-sm-offset-3 col-xs-12">
              <Paper className="unauthed-box">
                <div className="logo-container">
                  <Logo width={200} />
                </div>
                <form onSubmit={this.handleSubmit}>
                  <div className="row">
                    <div className="col-xs-12">
                      <Field
                        name="password"
                        value={password}
                        onChange={this.handleChange}
                        label="New Password"
                        type="password"
                        helpText={this.getPasswordHelp(password)}
                        disabled={this.state.fetching}
                      />
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-xs-12">
                      <Field
                        name="confirmPassword"
                        value={confirmPassword}
                        onChange={this.handleChange}
                        label="Confirm Password"
                        type="password"
                        style={{marginBottom: 16}}
                        disabled={this.state.fetching}
                      />
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-xs">
                      <Button
                        variant="contained"
                        color="primary"
                        style={{float: "right"}}
                        onClick={this.handleSubmit}
                        disabled={this.state.fetching}>
                        Submit
                      </Button>
                    </div>
                  </div>
                </form>
              </Paper>
              {this.state.fetching && <LinearProgress mode="indeterminate" />}
              {this.state.error && <div className="unauthed-error">{this.state.error}</div>}
            </div>
          </div>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/pages/PasswordReset/index.jsx